import { render, staticRenderFns } from "./WalletDetailDialog.vue?vue&type=template&id=03930082&scoped=true"
import script from "./WalletDetailDialog.vue?vue&type=script&lang=js"
export * from "./WalletDetailDialog.vue?vue&type=script&lang=js"
import style0 from "./WalletDetailDialog.vue?vue&type=style&index=0&id=03930082&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03930082",
  null
  
)

export default component.exports